import { VariationFe } from "@intelligems/ig-types/fe-only/variations";
import { AgVariationPrice } from "@src/store/slices/agProducts/types";
import { getPriceFromProductVariant } from "@src/store/slices/agProducts/util/getPriceFromProductVariant";
import { ShopifyProductVariant } from "@src/store/slices/products/types";

export function shopifyProductVariantToVariationPrice(
  variant: ShopifyProductVariant,
  variation: VariationFe
): AgVariationPrice {
  return {
    id: variant.id,
    name: variation.name,
    variationId: variation.id,
    price: getPriceFromProductVariant(variation, variant.price),
    ogPrice: variant.price,
    compareAtPrice: getPriceFromProductVariant(
      variation,
      variant.compareAtPrice
    ),
    ogCompareAtPrice: variant.compareAtPrice ?? null,
    subscriptionDiscount: null,
    subscriptionDiscountType: null,
  };
}
